// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Webradio.css */

/* Conteneur principal */
.webradio-container {
  max-width: 900px;
  margin: 40px auto;
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
}

/* Titre principal */
.webradio-title {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin-bottom: 20px;
}

/* Liste des épisodes en mode cartes */
.episode-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  padding: 0;
  margin: 0;
}

/* Carte d'un épisode */
.episode-item {
  background: #f8f8f8;
  border-radius: 10px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  padding: 15px;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

/* Effet au survol */
.episode-item:hover {
  transform: translateY(-5px);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

/* Titre de l'épisode */
.episode-title {
  font-size: 18px;
  font-weight: bold;
  color: #222;
  margin-bottom: 10px;
}

/* Date */
.episode-date {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
}

/* Description */
.episode-description {
  font-size: 14px;
  color: #444;
  margin-bottom: 10px;
}

/* Lecteur audio */
.audio-player {
  width: 100%;
  margin-top: 10px;
}

/* Bouton de like */
.like-button {
  background: #ff4d4d;
  border: none;
  color: white;
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 5px;
  margin-top: 10px;
  transition: background 0.3s;
}

.like-button:hover {
  background: #e60000;
}

@keyframes blink {
  from { opacity: 0.6; }
  to { opacity: 1; }
}

/* Webradio.css - Amélioration des styles pour les filtres */
.filters {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
}

.filters select, .filters input {
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background: white;
  font-size: 14px;
  cursor: pointer;
  flex: 1 1;
  min-width: 150px;
  max-width: 200px;
}

.filters button {
  padding: 6px 12px;
  font-size: 12px;
  background: #ff4d4d;
  color: white;
  border: none;
  transition: background 0.3s ease-in-out;
  min-width: auto;
  max-width: 120px;
}

.filters button:hover {
  background: #e60000;
}
/* Style pour les contes racontés */
.episode-conte {
  background: #ffe6cc;
  border-left: 5px solid #ff9800;
}

/* Style pour les émissions */
.episode-emission {
  background: #e6f7ff;
  border-left: 5px solid #007bff;
}

/* Style pour les podcasts */
.episode-podcast {
  background: #e6ffe6;
  border-left: 5px solid #28a745;
}

/* Style pour les Blagues */
.episode-blague{
  background: #fae6ff;
  border-left: 5px solid #b64cd1;
}


/* Style par défaut */
.episode-default {
  background: #f8f8f8;
  border-left: 5px solid #ccc;
}

@media (max-width: 600px) {
  .filters {
      flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/composant/container/Webradio/Webradio.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB,wBAAwB;AACxB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,mEAAmE;EACnE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,OAAO,YAAY,EAAE;EACrB,KAAK,UAAU,EAAE;AACnB;;AAEA,4DAA4D;AAC5D;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,uCAAuC;EACvC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,4BAA4B;AAC5B;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;;AAGA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE;MACI,sBAAsB;EAC1B;AACF","sourcesContent":["/* Webradio.css */\n\n/* Conteneur principal */\n.webradio-container {\n  max-width: 900px;\n  margin: 40px auto;\n  padding: 20px;\n  background: #ffffff;\n  border-radius: 10px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  text-align: center;\n}\n\n/* Titre principal */\n.webradio-title {\n  font-size: 24px;\n  font-weight: bold;\n  color: #333;\n  margin-bottom: 20px;\n}\n\n/* Liste des épisodes en mode cartes */\n.episode-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n  padding: 0;\n  margin: 0;\n}\n\n/* Carte d'un épisode */\n.episode-item {\n  background: #f8f8f8;\n  border-radius: 10px;\n  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);\n  padding: 15px;\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n/* Effet au survol */\n.episode-item:hover {\n  transform: translateY(-5px);\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\n}\n\n/* Titre de l'épisode */\n.episode-title {\n  font-size: 18px;\n  font-weight: bold;\n  color: #222;\n  margin-bottom: 10px;\n}\n\n/* Date */\n.episode-date {\n  font-size: 14px;\n  color: #666;\n  margin-bottom: 10px;\n}\n\n/* Description */\n.episode-description {\n  font-size: 14px;\n  color: #444;\n  margin-bottom: 10px;\n}\n\n/* Lecteur audio */\n.audio-player {\n  width: 100%;\n  margin-top: 10px;\n}\n\n/* Bouton de like */\n.like-button {\n  background: #ff4d4d;\n  border: none;\n  color: white;\n  padding: 6px 12px;\n  font-size: 14px;\n  cursor: pointer;\n  border-radius: 5px;\n  margin-top: 10px;\n  transition: background 0.3s;\n}\n\n.like-button:hover {\n  background: #e60000;\n}\n\n@keyframes blink {\n  from { opacity: 0.6; }\n  to { opacity: 1; }\n}\n\n/* Webradio.css - Amélioration des styles pour les filtres */\n.filters {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 10px;\n  margin-bottom: 20px;\n}\n\n.filters select, .filters input {\n  padding: 10px;\n  border-radius: 5px;\n  border: 1px solid #ddd;\n  background: white;\n  font-size: 14px;\n  cursor: pointer;\n  flex: 1;\n  min-width: 150px;\n  max-width: 200px;\n}\n\n.filters button {\n  padding: 6px 12px;\n  font-size: 12px;\n  background: #ff4d4d;\n  color: white;\n  border: none;\n  transition: background 0.3s ease-in-out;\n  min-width: auto;\n  max-width: 120px;\n}\n\n.filters button:hover {\n  background: #e60000;\n}\n/* Style pour les contes racontés */\n.episode-conte {\n  background: #ffe6cc;\n  border-left: 5px solid #ff9800;\n}\n\n/* Style pour les émissions */\n.episode-emission {\n  background: #e6f7ff;\n  border-left: 5px solid #007bff;\n}\n\n/* Style pour les podcasts */\n.episode-podcast {\n  background: #e6ffe6;\n  border-left: 5px solid #28a745;\n}\n\n/* Style pour les Blagues */\n.episode-blague{\n  background: #fae6ff;\n  border-left: 5px solid #b64cd1;\n}\n\n\n/* Style par défaut */\n.episode-default {\n  background: #f8f8f8;\n  border-left: 5px solid #ccc;\n}\n\n@media (max-width: 600px) {\n  .filters {\n      flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
